import api from './api.service';

export interface ClassificationGlRow {
  classification: string;
  stage: string;
  account_id: string;
}

export interface ClassificationGlRowWithId extends ClassificationGlRow {
  id: string;
}

export interface ItemClassificationGlResponse {
  rows: ClassificationGlRowWithId[];
  classifications: string[];
  stages: string[];
}

const STAGE_LABELS: Record<string, string> = {
  GRN_DEBIT: 'GRN Debit',
  GRN_CREDIT: 'GRN Credit (e.g. Provision for AP)',
  SALES_REVENUE: 'Sales Revenue',
  SUBCONTRACT_EXPENSE: 'Subcontract Expense',
};

const CLASSIFICATION_LABELS: Record<string, string> = {
  Stock: 'Stock',
  'Non-Stock': 'Non-Stock',
  Service: 'Service',
  Subcontract: 'Subcontract / Job-work',
};

export function getStageLabel(stage: string): string {
  return STAGE_LABELS[stage] ?? stage;
}

export function getClassificationLabel(classification: string): string {
  return CLASSIFICATION_LABELS[classification] ?? classification;
}

export const itemClassificationGlApi = {
  get: (): Promise<ItemClassificationGlResponse> =>
    api.get('/inventory/item-classification-gl-accounts').then((r: any) => {
      const d = r?.data ?? r;
      return { rows: d?.rows ?? [], classifications: d?.classifications ?? [], stages: d?.stages ?? [] };
    }),

  put: (rows: ClassificationGlRow[]): Promise<ClassificationGlRowWithId[]> =>
    api.put('/inventory/item-classification-gl-accounts', { rows }).then((r: any) => r?.data ?? r),
};
